export default __webpack_public_path__ + "static/media/03.9e4b88e3.jpg";